import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';

import Money from '../../../common/money';
import Date from '../../../common/date';
import { getTopUpAmount } from '../../helpers';
import { fullName } from '../../../common/helpers/users';
import { t } from '../../../../modules/infra/i18n';

const GiftCardList = ({ setGiftCard, giftCards }) => {
  return (
    <div>
      <div
        className="c-heading--small u-text-center u-lh-2 u-mt++ u-max-width-710 u-margin-auto"
        display-if={!giftCards.length}
      >
        {t('register:gift_cards.list.no_outstanding_cards')}
      </div>
      <ReactTable
        className="c-table-new c-table--small c-table--min-width o-wrapper u-margin-auto u-mv+"
        data={giftCards}
        defaultPageSize={20}
        minRows={0}
        pageText={''}
        previousText={t('common:pagination.previous')}
        nextText={t('common:pagination.next')}
        ofText={t('common:pagination.of')}
        rowsText={t('common:pagination.rows')}
        showPageSizeOptions={false}
        display-if={giftCards.length}
        columns={[
          {
            Header: t('register:gift_cards.list.header_gift_card'),
            accessor: 'code',
            Cell: ({ value }) => <code>{value}</code>,
          },
          {
            Header: t('register:gift_cards.list.header_initial_balance'),
            accessor: 'initialBalance',
            Cell: row => <Money cents={row.value} />,
          },
          {
            id: 'topUpBalance',
            Header: t('register:gift_cards.list.header_total_top_up'),
            accessor: item => getTopUpAmount(item),
            Cell: row => <Money cents={row.value} />,
          },
          {
            Header: t('register:gift_cards.list.header_outstanding_balance'),
            accessor: 'outstandingBalance',
            className: 'u-co-primary u-type--bold',
            Cell: row => <Money cents={row.value} />,
          },
          {
            Header: t('register:gift_cards.list.header_date_created'),
            accessor: 'createdAt',
            Cell: row => <Date>{row.value}</Date>,
          },
          {
            Header: t('register:gift_cards.list.header_designated_barber'),
            id: 'barber',
            accessor: giftCard => (giftCard.barber ? fullName(giftCard.barber, true) : ''),
            Cell: row => row.value,
          },
        ]}
        defaultSorted={[
          {
            id: 'createdAt',
            desc: true,
          },
        ]}
        getTrProps={(state, rowInfo) => ({
          onClick: () => setGiftCard(rowInfo.row._original),
        })}
      />
    </div>
  );
};

GiftCardList.propTypes = {
  giftCards: PropTypes.arrayOf(PropTypes.shape({
    code: PropTypes.string,
    outstandingBalance: PropTypes.number,
    initialBalance: PropTypes.number,
  })),
  setGiftCard: PropTypes.func.isRequired,
};
GiftCardList.defaultProps = {
  giftCards: [],
};

export default GiftCardList;
